export const reload = window.location.reload.bind(window.location);
